<div class="title_ex" >
  <div class="left_b" >
    Терминал 1
  </div>
  <div  class="caenter_b" >
    ИВАНОВ СЕМЁН СЕМЁНОВИЧ 01.01.2000 Категория ВУ: A/B/M
  </div>
  <div class="ringht_b" >
    Осталось: <span #timerHTML>20:00</span>
  </div>
</div>
<div style="display: flex; flex-wrap: wrap; gap: 10px; padding-top: 20px; ">
  <ng-container *ngFor="let q of this.q_list; let  i = index">
    <div
      [class]="{'line_list_q': true, 'active': i == active_quantity, 'checked':  q.emulator_gibdd_cheked && !finish_question, 'success': finish_question == true && q.status == 1,   'error': finish_question == true && q.status == 2, 'none_check': finish_question == true && q.status == 0,}"
      (click)="open_quation(i)"></div>
  </ng-container>
</div>

<ng-container *ngIf="active_quantity <= -1">
  <div>
    <div class="el_q_main">
      <div class="colum_el_q_main">
        <ng-container *ngFor="let q of this.q_list; let  i = index">
          <ng-container *ngIf="i <= 4 && i >= 0">
            <div [class]="{'bottom_q_main': true, 'q_main_1': true }"
                 (click)="open_quation(i)">
              <div class="number_q">
                {{ i + 1 }}
              </div>
              <div *ngIf="q.emulator_gibdd_cheked == true ||  finish_question == true" class="result_cheket">
                <div *ngIf="this.q_list[i].status == 0" class="none_check">
                  Ответ отсутствует
                </div>
                <div *ngIf="this.q_list[i].status == 2" class="error">
                  Ответ неправильный
                </div>
                <div *ngIf="this.q_list[i].status == 1" class="success">
                  Ответ правильный
                </div>
              </div>
              <ng-container *ngIf="!this.q_list[i].question.img">
                <div class="none_img">
                  Вопрос без изображения
                </div>
              </ng-container>
              <ng-container *ngIf="this.q_list[i].question.img">
                <div>
                  <img src="{{this.q_list[i].question.img}}" style="width: 100%; min-height: 100px; object-fit: cover;
  vertical-align: bottom;">
                </div>
              </ng-container>
              <div class="text_q">
                {{ q.question.text }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="colum_el_q_main">
        <ng-container *ngFor="let q of this.q_list; let  i = index">
          <ng-container *ngIf="i <= 9 && i >= 5">
            <div [class]="{'bottom_q_main': true, 'q_main_2': true }"
                 (click)="open_quation(i)">
              <div class="number_q">
                {{ i + 1 }}
              </div>
              <div *ngIf="q.emulator_gibdd_cheked == true ||  finish_question == true" class="result_cheket">
                <div *ngIf="this.q_list[i].status == 0" class="none_check">
                  Ответ отсутствует
                </div>
                <div *ngIf="this.q_list[i].status == 2" class="error">
                  Ответ неправильный
                </div>
                <div *ngIf="this.q_list[i].status == 1" class="success">
                  Ответ правильный
                </div>
              </div>
              <ng-container *ngIf="!this.q_list[i].question.img">
                <div class="none_img">
                  Вопрос без изображения
                </div>
              </ng-container>
              <ng-container *ngIf="this.q_list[i].question.img">
                <div>
                  <img src="{{this.q_list[i].question.img}}" style="width: 100%; min-height: 100px; object-fit: cover;
  vertical-align: bottom;">
                </div>
              </ng-container>
              <div class="text_q">
                {{ q.question.text }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="colum_el_q_main">
        <ng-container *ngFor="let q of this.q_list; let  i = index">
          <ng-container *ngIf="i <= 14 && i >= 10">
            <div [class]="{'bottom_q_main': true, 'q_main_3': true,   }"
                 (click)="open_quation(i)">
              <div class="number_q">
                {{ i + 1 }}
              </div>
              <div *ngIf="q.emulator_gibdd_cheked == true ||  finish_question == true" class="result_cheket">
                <div *ngIf="this.q_list[i].status == 0" class="none_check">
                  Ответ отсутствует
                </div>
                <div *ngIf="this.q_list[i].status == 2" class="error">
                  Ответ неправильный
                </div>
                <div *ngIf="this.q_list[i].status == 1" class="success">
                  Ответ правильный
                </div>
              </div>
              <ng-container *ngIf="!this.q_list[i].question.img">
                <div class="none_img">
                  Вопрос без изображения
                </div>
              </ng-container>
              <ng-container *ngIf="this.q_list[i].question.img">
                <div>
                  <img src="{{this.q_list[i].question.img}}" style="width: 100%; min-height: 100px; object-fit: cover;
  vertical-align: bottom;">
                </div>
              </ng-container>
              <div class="text_q">
                {{ q.question.text }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="colum_el_q_main">
        <ng-container *ngFor="let q of this.q_list; let  i = index">
          <ng-container *ngIf="i <= 19 && i >= 15">
            <div [class]="{'bottom_q_main': true, 'q_main_4': true }"
                 (click)="open_quation(i)">
              <div class="number_q">
                {{ i + 1 }}
              </div>
              <div *ngIf="q.emulator_gibdd_cheked == true ||  finish_question == true" class="result_cheket">
                <div *ngIf="this.q_list[i].status == 0" class="none_check">
                  Ответ отсутствует
                </div>
                <div *ngIf="this.q_list[i].status == 2" class="error">
                  Ответ неправильный
                </div>
                <div *ngIf="this.q_list[i].status == 1" class="success">
                  Ответ правильный
                </div>
              </div>
              <ng-container *ngIf="!this.q_list[i].question.img">
                <div class="none_img">
                  Вопрос без изображения
                </div>
              </ng-container>
              <ng-container *ngIf="this.q_list[i].question.img">
                <div>
                  <img src="{{this.q_list[i].question.img}}" style="width: 100%; min-height: 100px; object-fit: cover;
  vertical-align: bottom;">
                </div>
              </ng-container>
              <div class="text_q">
                {{ q.question.text }}
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="active_quantity > -1">
  <div style="color: #000; padding-top: 20px;">
    <div>
      <ng-container *ngIf="!this.q_list[active_quantity].question.img">
        <div class="none_img">
          Вопрос без изображения
        </div>
      </ng-container>
      <ng-container *ngIf="this.q_list[active_quantity].question.img">
        <div>
          <img src="{{this.q_list[active_quantity].question.img}}" style="width: 100%;">
        </div>
      </ng-container>

    </div>
    <div style="text-align: center; font-size: 20px; padding-top: 10px; padding-bottom: 10px;">
      {{ this.q_list[active_quantity].question.text }}
    </div>
    <ng-content *ngIf="finish_question == true && this.q_list[active_quantity].status == 0">
      <div style="padding-bottom: 10px;">
        <div style="background: #f8f68f; padding: 10px; color: #000;">
          Вы не успели ответить на вопрос
        </div>
      </div>
    </ng-content>
    <div style="padding-bottom: 10px; display: grid; gap: 10px;">
      <ng-container *ngFor="let answer of this.q_list[active_quantity].answers; let  i = index">
        <div
          [class]="{'answer':true, 'select': answer.emulator_gibdd_select == true && !answer.emulator_gibdd_cheked && !finish_question ,  'chacked': answer.emulator_gibdd_cheked == true && !finish_question ,  'success': answer.correct == true && finish_question ,  'error': answer.correct == false && answer.emulator_gibdd_cheked == true && finish_question }"
          (click)="select_answer(i)">
          <div>
            <div class="number">
              {{ i + 1 }}
            </div>
          </div>
          <div>
            {{ answer.text }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <div style="display: flex; gap: 10px;">
    <div style="width: 100%;">
      <button
        [class]="{'conntroll_q': true, 'conntroll_disable': !this.q_list[this.active_quantity].emulator_gibdd_select || this.q_list[this.active_quantity].emulator_gibdd_cheked == true || finish_question == true  }"
        (click)="check_q()">Ответить
      </button>
    </div>
    <div style="display: flex; gap: 10px;">
      <div>
        <button [class]="{'conntroll_q': true, 'conntroll_disable': active_quantity <= 0}"
                (click)="prew_quation(active_quantity-1)">К предыдущему
        </button>
      </div>
      <div>
        <button class="conntroll_q" (click)="open_quation(-1)">К перечню</button>
      </div>
      <div>
        <button [class]="{'conntroll_q': true, 'conntroll_disable': active_quantity >= q_list.length -1}"
                (click)="next_quation(active_quantity+1)">К следующему
        </button>
      </div>
    </div>
  </div>
  <div style="padding-top: 20px; font-size: 16px; color: #000;" *ngIf="this.finish_question">
    <ng-container *ngFor="let answer of this.q_list[active_quantity].answers; let  i = index">
      <ng-container *ngIf="answer.correct == true">
        {{ answer.description }}
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<div *ngIf="finish_question == true && close_finish_result == false" (click)=" this.close_finish_result = true" style="z-index: 99; position: fixed; top: 0px; left: 0px; bottom: 0px; right: 0px; padding: 20px; background: rgba(255, 255, 255, 0.7); display: flex; justify-content: center; align-items: center;">
  <div *ngIf="status_exzamen == false" style="padding: 20px; background: #c81010;  color: #fff; text-align: center; display: grid;  gap: 10px; font-size: 20px">
    <div>
      Экзамен не сдан
    </div>
    <div style="max-width: 600px;">
      Для просмотра экзаменационных билетов с комментариями нажмите клавишу Enter на клавиатуре или нажмите левую кнопку мыши
    </div>
    <div class="reult_status_info" >
      <div style="padding: 10px; background: rgba(255, 255, 255, 0.5);">
        Ошибок: {{ conutErorr() }}
      </div>
      <div style="padding: 10px; background: rgba(255, 255, 255, 0.5);">
        Время: {{getTimeUs()}}
      </div>
      <div style="padding: 10px; background: rgba(255, 255, 255, 0.5);">
        Вопросов: 20
      </div>
    </div>
  </div>
  <div *ngIf="status_exzamen == true" style="padding: 20px; background: #238328;  color: #fff; text-align: center; display: grid;  gap: 10px; font-size: 20px">
    <div>
      Экзамен сдан
    </div>
    <div style="max-width: 600px;">
      Для просмотра экзаменационных билетов с комментариями нажмите клавишу Enter на клавиатуре или нажмите левую кнопку мыши
    </div>
    <div class="reult_status_info" >
      <div style="padding: 10px; background: rgba(255, 255, 255, 0.5);">
        Ошибок: {{ conutErorr() }}
      </div>
      <div style="padding: 10px; background: rgba(255, 255, 255, 0.5);">
        Время: {{getTimeUs()}}
      </div>
      <div style="padding: 10px; background: rgba(255, 255, 255, 0.5);">
        Вопросов: 20
      </div>
    </div>
  </div>
</div>
